function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#b3c315",
  d: "M70 54h41v18H70z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#96a40a",
  d: "M65 54h5v18h-5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#b3c315",
  d: "M94 50h13v3H94z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#96a40a",
  d: "M89 50h5v3h-5z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#b3c315",
  d: "M74 50h13v3H74z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#96a40a",
  d: "M69 50h5v3h-5z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#b977c7",
  d: "M72 92h13v3H72z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#9e5cac",
  d: "M67 92h5v3h-5z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#b977c7",
  d: "M51 92h13v3H51z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#9e5cac",
  d: "M46 92h5v3h-5z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#49c3f5",
  d: "M92 75h19v19H92z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#109ad4",
  d: "M87 75h5v19h-5z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M25 97h86l-18 19H43L25 97z",
  fill: "#b977c7"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#9e5cac",
  d: "M20 97l18 19h5L25 97z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M111 36H25l18-19h50l18 19z",
  fill: "#f1b014"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#f09108",
  d: "M43 17h-5L20 36h5z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#f1b014",
  d: "M51 12h14v3H51z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "#f09108",
  d: "M46 12h5v3h-5z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#f1b014",
  d: "M73 12h14v3H73z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "#f09108",
  d: "M68 12h5v3h-5z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#49c3f5",
  d: "M25 39h18v26H25z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#109ad4",
  d: "M20 39h5v26h-5z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fill: "#d25e4d",
  d: "M20 68h5v26h-5z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fill: "#e67666",
  d: "M25 68h18v26H25z"
});

var SvgGetwid = function SvgGetwid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
};

export default SvgGetwid;